import ObjectID from 'bson-objectid'

export function createOption() {
  return {
    _id: ObjectID().toHexString(),
    name: '',
  }
}

export function ensureOptionIds(options = [], { forceNew = false } = {}) {
  return (Array.isArray(options) ? options : []).map(option => ({
    ...option,
    _id: forceNew || !option?._id ? ObjectID().toHexString() : option._id,
  }))
}
